<template>
  <div class="qrcode-invite">
    <img class="qrcode-invite-box" :src="shartImg" v-show="shartImg !=''" alt="">
    <canvas v-show="shartImg ==''" class="qrcode-invite-box" id="canvas-img" width="670" height="750"></canvas>
    <div class="btn-box">
      <!-- <pi-button type="primary" block @click="goQrcode">微信好友</pi-button> -->
      <!-- <pi-button type="primary" block @click="saveImg">保存到本地</pi-button> -->
      长按图片保存到手机
    </div>
    <div class="pi-qrcode-show" ref="qrcodeDiv" style="width:200px;height:200px;display:none"></div>
  </div>
</template>
<script>
import boxBg from '@/assets/image/invite-box-bg.png';
import { mapState } from "vuex";
import { getOperInfo } from "../../common/api/index";
import{addQrcode} from '@/common/old/public/add-js.js'
import {
  getUserBaseInfo,
} from "../../common/api";
export default {
  name: 'qrcode-invite',
  data(){
    return{
      logoUrl: '',
      oprPkId: '',
      url: '',
      myQrcodeImg: '',
      shartImg:'',
      operData: {},
      phone: '',
      userInfo: {}
    }
  },
  computed: {
    ...mapState(["app"]),
  },
  methods: {
    getOperInfo(){
      getOperInfo({oprPkId: this.oprPkId}).then(data => {
        if (data.status === this.$config.ajaxStatus) {
          if(data.data[0]){
            this.operData = data.data[0];
            this.logoUrl = this.$config.fileImg + this.operData.appSystemLogo;
          }
        }
        
        this.getUserBaseInfo();
      })
    },
    getUserBaseInfo(){
      getUserBaseInfo(null)
        .then(response => {
          if (
              response.status === this.$config.ajaxStatus &&
              response.data.length > 0
            ) {
              var reg = /^(\d{3})\d{4}(\d{4})$/;
              this.userInfo = response.data[0];
              this.phone = this.userInfo.phoneNo.replace(reg, "$1****$2");
            }
          this.myCode();
        })
    },
    async myCode(){
      await addQrcode();
      this.qrcodeShow();
    },
    qrcodeShow() {
      if (!window.QRCode) {
        setTimeout(() => {
          this.qrcodeShow();
        }, 200);
      } else {
        if (this.url != "") {
          this.$nextTick(() => {
            const divObj = this.$refs["qrcodeDiv"];
            divObj.innerHTML = "";
              this.qrcodeObj = new window.QRCode(divObj, {
                width: 200,
                height: 200
              });
            this.qrcodeObj.makeCode(this.url);
            console.log(divObj);
            let canvas = divObj.getElementsByTagName('canvas')[0];
            this.myQrcodeImg = canvas.toDataURL("image/png");
            this.canvasImg();
          });
        }
      }
    },
    saveImg(){},
    async canvasImg() {
      const canvasObj= window.document.getElementById("canvas-img");
      const myctx = canvasObj.getContext("2d");
      const t = 2;
      const w = canvasObj.width * t;
      const h = canvasObj.height * t;
      canvasObj.width = w;
      canvasObj.height = h;
      const bg = await this.loadImg(boxBg);
      if (bg) {
        myctx.drawImage(bg, 0, 0, canvasObj.width, canvasObj.height);
      }
      myctx.font = (70 * 2)+"px  bold 黑体";
      myctx.textAlign = "center";
      myctx.fillStyle = "#14CC80";
      myctx.fillText("为美好生活充电", canvasObj.width / 2, 135 * 2);

      myctx.font = (28 * 2)+"px  bold 黑体";
      myctx.textAlign = "center";
      myctx.fillStyle = "#22863B";
      myctx.fillText(this.operData.oprSystemName, canvasObj.width / 2, 180 * 2);

      const myImg = await this.loadImg(this.app.userInfo.headImgUrl);
      if (myImg) {
        myctx.drawImage(myImg,  275 * t,  255 * t, 120 * t,  120 * t);
      }

      myctx.font = (28 * 2)+"px  bold 黑体";
      myctx.fillStyle = "#fff";
      myctx.fillText(this.phone, canvasObj.width / 2, 420 * 2);

      myctx.fillStyle = "#fff";
      myctx.fillRect(215 * t,  446 * t, 240 * t,  240 * t);

      const qrcode = await this.loadImg(this.myQrcodeImg);
        if (qrcode) {
          myctx.drawImage(qrcode,  235 * t,  466 * t, 200 * t,  200 * t);
        }
      if(this.logoUrl != ''){
        const logo = await this.loadImg(this.logoUrl);
        if (logo) {
          myctx.drawImage(logo,  (canvasObj.width / 2 - (50 * t / 2)),  551 * t, 50 * t,  50 * t);
        }
      }

      myctx.font = (28 * 2)+"px  bold 黑体";
      myctx.fillStyle = "#fff";
      myctx.fillText("长按识别二维码", canvasObj.width / 2, 725 * 2);

      this.shartImg = canvasObj.toDataURL("image/png");
    },
    loadImg(src) {
      var that = this;
      return new Promise((resolve) => {
        const beauty = new Image();
        beauty.crossOrigin = "anonymous"; //关键

        beauty.src = src;
        if (beauty.complete) {
          resolve(beauty);
        } else {
          beauty.onload = function() {
            resolve(beauty);
          };
          beauty.onerror = function() {
            resolve(null);
            that.$toast("图片加载失败");
          };
        }
      });
    }
  },

  mounted() {
    this.oprPkId = this.$common.get("oprPkId");
    this.url = window.location.origin + '/#/?oprPkId='+ this.oprPkId+'&inviter='+this.app.userInfo.userPkId;
    this.getOperInfo();
  },
}
</script>
<style lang="less">
  .qrcode-invite{
    height: 100%;
    padding: 0.4rem;
    box-sizing: border-box;
    background-image: url('../../assets/image/invite-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .qrcode-invite-box{
      height: 7.5rem;
      width: 100%;
    }
    img.qrcode-invite-box{
      pointer-events:auto
    }
    .btn-box{
      margin-top: 0.68rem;
      text-align: center;
      color: #14CC80;
    }
  }
</style>